/**
 * PPF maturity calculation (shared by web, mobile, calculator-service).
 */

export function calculatePpf(yearlyInvestment, interestRate, years, investmentFrequency = "yearly") {
  let totalAmount = 0;
  let totalInvestment = 0;

  if (investmentFrequency === "yearly") {
    for (let year = 0; year < years; year += 1) {
      totalAmount += yearlyInvestment;
      totalInvestment += yearlyInvestment;
      const annualInterest = totalAmount * (interestRate / 100);
      totalAmount += annualInterest;
    }
  } else {
    const monthlyAmount = yearlyInvestment / 12;
    for (let year = 0; year < years; year += 1) {
      for (let month = 0; month < 12; month += 1) {
        totalAmount += monthlyAmount;
        totalInvestment += monthlyAmount;
      }
      const annualInterest = totalAmount * (interestRate / 100);
      totalAmount += annualInterest;
    }
  }

  const totalInterest = totalAmount - totalInvestment;

  return {
    totalInvestment: Math.round(totalInvestment),
    totalInterest: Math.round(totalInterest),
    maturityAmount: Math.round(totalAmount),
  };
}
